/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    IMPORTS
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


//import '../../scss/master.scss';

import JQuery from 'jquery';
// import MicAccessTool from "nvs-accessibility";


import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// for Vue
window.$ = window.JQuery = JQuery;

import 'winkler_projects.js';








/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    PAGE LOADER FUNCTION
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

function initPageLoader() {
  const startTime = performance.now();
  const root = document.documentElement;
  const overlay = document.getElementById('loading-overlay');
  const targetHash = window.location.hash;

  if (!overlay) return;

  function unlockScroll() {
    // Step 1: If there's a hash, jump to it INSTANTLY behind the opaque overlay
    if (targetHash) {
      const targetElement = document.querySelector(targetHash);
      if (targetElement) {
        // Temporarily unlock overflow to apply scroll position
        root.classList.remove('js-scroll-locked');
        targetElement.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    } else {
      root.classList.remove('js-scroll-locked');
    }

    // Step 2: Fade out overlay AFTER the scroll position is already set
    requestAnimationFrame(() => {
      overlay.classList.add('fade-out');

      setTimeout(function () {
        overlay.remove();
        
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'auto';
        }

        const durationMs = Math.round(performance.now() - startTime);
        console.log("Page locked for " + durationMs + " miliseconds");
      }, 1200);
    });
  }

  if (document.readyState === 'complete') {
    unlockScroll();
  } else {
    window.addEventListener('load', unlockScroll, { once: true });
  }
}

initPageLoader();




/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    ANCHOR SCROLL
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


/**
 * Ensures cross-page anchor navigation targets the exact scroll position
 * after layout render and DOM load.
 */
function handleInitialAnchorScroll() {
  const hash = window.location.hash;
  if (!hash) return;

  const targetElement = document.querySelector(hash);
  if (!targetElement) return;

  // Wait for the browser paint and layout pass
  requestAnimationFrame(() => {
    setTimeout(() => {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 100); // Brief delay for dynamic layouts/fonts
  });
}

document.addEventListener('DOMContentLoaded', handleInitialAnchorScroll);



/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    HEADER SCROLL // DISABLED
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


function headerScroll() {
  // 1. Select the header element


  const scrollTarget = document.querySelector('header');

  // Guard clause: Only run the scroll logic if the element exists on this specific page
  if (!scrollTarget) return;

  // Set your scroll threshold in pixels
  const scrollThreshold = 500;
  let isScrolled = false;
  let ticking = false;

  function updateScrollState() {
    const currentScroll = window.scrollY || window.pageYOffset;

    // Check if scrolled past the 200px threshold
    if (currentScroll >= scrollThreshold && !isScrolled) {
      scrollTarget.classList.add('is-scrolled');
      isScrolled = true;
    } else if (currentScroll < scrollThreshold && isScrolled) {
      scrollTarget.classList.remove('is-scrolled');
      isScrolled = false;
    }

    ticking = false;
  }

  // Run an initial check immediately in case the page loads/refreshes already scrolled down
  updateScrollState();

  // 2. Listen for the scroll event
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }, { passive: true });
}




/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    HEADROOM custom js
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

document.addEventListener('DOMContentLoaded', function () {
  initSmartHeader();
});

function initSmartHeader() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  let lastScrollY = window.scrollY || window.pageYOffset;
  let ticking = false;

  // Configuration settings (in pixels)
  const tolerance = 10;      // Minimum scroll distance before triggering hide/show
  const topThreshold = 50;   // Keep header visible when near the absolute top

  function updateHeader() {
    const currentScrollY = window.scrollY || window.pageYOffset;
    const diff = currentScrollY - lastScrollY;

    // 0. GUARD CLAUSE: If the dropdown menu is open (.is-active), force the header visible
    if (header.classList.contains('is-active')) {
      header.classList.remove('is-hidden');
      lastScrollY = currentScrollY;
      ticking = false;
      return; // Stop execution here so it doesn't try to hide
    }

    // 1. At the very top: Always show and remove scrolled state
    if (currentScrollY <= topThreshold) {
      header.classList.remove('is-hidden');
      header.classList.remove('is-scrolled');
    } 
    // 2. Scrolling DOWN past tolerance: Hide the header
    else if (diff > tolerance && !header.classList.contains('is-hidden')) {
      header.classList.add('is-hidden');
      header.classList.add('is-scrolled');
    } 
    // 3. Scrolling UP past tolerance: Show the header
    else if (diff < -tolerance && header.classList.contains('is-hidden')) {
      header.classList.remove('is-hidden');
      header.classList.add('is-scrolled');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
}




/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    CARDS SWIPER
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


let swiperCards = [];

function initCardsSwiper() {

document.querySelectorAll('.js-swiper--cards').forEach(container => {

  const wrapper = container.querySelector('.card-section__wrapper');

  if (!wrapper) return;

  if (window.innerWidth < 992) {

    if (!container.swiper) {

      container.classList.add('swiper');
      wrapper.classList.add('swiper-wrapper');

      wrapper.querySelectorAll('.image-card').forEach(el => {
        el.classList.add('swiper-slide');
      });

      const swiper = new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        grabCursor: true,

        breakpoints: {
          576: { slidesPerView: 1.4 },
          768: { slidesPerView: 1.6 }
        }
      });

      swiperCards.push(swiper);
    }

  } else {

    if (container.swiper) {

      container.swiper.destroy(true, true);

      container.classList.remove('swiper');
      wrapper.classList.remove('swiper-wrapper');

      wrapper.querySelectorAll('.image-card').forEach(el => {
        el.classList.remove('swiper-slide');
      });
    }
  }
});
}





/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    ABOUT SPLIT VIDEO
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

export function initVideoBlock() {
	const videoBlock = document.querySelector('.js-video-block');
	const video = document.querySelector('.js-video');
	const marquee = document.querySelector('.js-marquee');

	if (!videoBlock || !video || !marquee) return;

	let animationPlayed = false;

	function runAnimation() {
		if (animationPlayed) return;
		animationPlayed = true;

		const moveAmount = marquee.scrollWidth - videoBlock.offsetWidth;

		video.pause();

		marquee.style.transition = 'transform 5s linear';
		marquee.style.transform = `translateX(-${moveAmount}px)`;
	}

	if (window.innerWidth >= 992) {
		videoBlock.addEventListener('mouseenter', runAnimation);
	}

	if (window.innerWidth < 992) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					runAnimation();
					observer.unobserve(videoBlock);
				}
			});
		}, { threshold: 0.6 });

		observer.observe(videoBlock);
	}

	marquee.addEventListener('transitionend', () => {
		video.play();
	});
}






/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    PROJECTS SHOWCASE - HOME
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

function initProjectSwiper() {

	const el = document.querySelector('.projects-showcase__swiper');

	if (!el || el.swiper) return;

	const showcase = el.closest('.projects-showcase') || el;
	let isMobile = window.innerWidth < 992;
	let isInView = false;
	let interval = null;

	/*
	-----------------------------------
	SWIPER (NO AUTOPLAY!)
	-----------------------------------
	*/

	const swiper = new Swiper(el, {

		loop: true,
		speed: 1200,

		observer: true,
		observeParents: true,

		allowTouchMove: true,
	});

	/*
	-----------------------------------
	ELEMENTS
	-----------------------------------
	*/

	const tabs = document.querySelectorAll('.projects-tab');

	const mobileTitles =
		document.querySelectorAll('.projects-tabs-mobile__title');

	const progressBars =
		document.querySelectorAll('.projects-progress');

	const counterCurrent =
		document.querySelector('.projects-tabs-mobile__counter .current');

	const counterTotal =
		document.querySelector('.projects-tabs-mobile__counter .total');

	if (counterTotal) {
		counterTotal.textContent = progressBars.length;
	}

	/*
	-----------------------------------
	RESET ALL PROGRESS
	-----------------------------------
	*/

	function resetProgress() {
		progressBars.forEach(bar => {
			bar.classList.remove('is-loading');
			bar.classList.remove('is-complete');
		});
	}

	/*
	-----------------------------------
	UPDATE DESKTOP
	-----------------------------------
	*/

	function updateDesktopTabs() {

		tabs.forEach(tab => tab.classList.remove('is-active'));

		if (tabs[swiper.realIndex]) {
			tabs[swiper.realIndex].classList.add('is-active');
		}
	}

		/*
	-----------------------------------
	DESKTOP TAB CLICK
	-----------------------------------
	*/

	tabs.forEach((tab) => {

		tab.addEventListener('click', () => {

			if (tab.classList.contains('is-active')) return;

			const index = Number(tab.dataset.slide);

			swiper.slideToLoop(index);

			if (isMobile && isInView) {
				restartAutoplay();
			}
		});
	});

	/*
	-----------------------------------
	MOBILE CORE LOGIC (SYNC 1:1)
	-----------------------------------
	*/

	function updateMobileTabs() {

		if (!isMobile) return;

		/*
		TITLE
		*/

		mobileTitles.forEach(t => t.classList.remove('is-active'));

		mobileTitles[swiper.realIndex]?.classList.add('is-active');

		/*
		COUNTER
		*/

		if (counterCurrent) {
			counterCurrent.textContent = swiper.realIndex + 1;
		}

		/*
		RESET
		*/

		resetProgress();

		/*
		IMPORTANT:
		- previous slides = complete
		- current = loading
		*/

		progressBars.forEach((bar, i) => {

			if (i < swiper.realIndex) {
				bar.classList.add('is-complete');
			}
		});

		/*
		CURRENT = LOADING (ONLY ONE ANIMATION)
		*/

		const currentBar =
			progressBars[swiper.realIndex];

		if (currentBar && isInView) {
			currentBar.classList.add('is-loading');
		}
	}

	/*
	-----------------------------------
	UI WRAPPER
	-----------------------------------
	*/

	function updateUI() {
		updateDesktopTabs();

		if (isMobile) {
			updateMobileTabs();
		}
	}

	/*
	-----------------------------------
	MOBILE AUTOPLAY (SYNCED 4s)
	-----------------------------------
	*/

	function startAutoplay() {

		if (!isMobile || !isInView) return;

		stopAutoplay();

		const currentBar = progressBars[swiper.realIndex];
		if (currentBar) {
			currentBar.classList.remove('is-loading');
			void currentBar.offsetWidth;
			currentBar.classList.add('is-loading');
		}

		interval = setInterval(() => {
			swiper.slideNext();
		}, 4000);
	}

	function stopAutoplay() {
		if (interval) {
			clearInterval(interval);
			interval = null;
		}

		const currentBar = progressBars[swiper.realIndex];
		if (currentBar) {
			currentBar.classList.remove('is-loading');
		}
	}

	function restartAutoplay() {
		if (!isMobile || !isInView) return;

		stopAutoplay();
		startAutoplay();
	}

	/*
	-----------------------------------
	INIT STATE
	-----------------------------------
	*/

	resetProgress();
	updateUI();

	/*
	-----------------------------------
	INTERSECTION OBSERVER (PLAY/PAUSE)
	-----------------------------------
	*/

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				isInView = true;
				startAutoplay();
			} else {
				isInView = false;
				stopAutoplay();
			}
		});
	}, {
		threshold: 0.2
	});

	observer.observe(showcase);

	/*
	-----------------------------------
	EVENTS
	-----------------------------------
	*/

	swiper.on('slideChange', () => {
		updateUI();
	});

	swiper.on('touchEnd', () => {
		if (isMobile && isInView) {
			restartAutoplay();
		}
	});

	window.addEventListener('resize', () => {
		isMobile = window.innerWidth < 992;
		if (!isMobile) {
			stopAutoplay();
		} else if (isInView) {
			startAutoplay();
		}
	});
}





/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    MASTER ARTICLE SWIPER
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

function initMasterArticleSwiper() {
	const el = document.querySelector('.js-master-article-swiper');

	if (!el || el.swiper) return;

	const swiper = new Swiper(el, {
		modules: [Pagination],
		loop: true,
		speed: 800,
		grabCursor: true,
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
	});
}





  
/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    MAIN NAVIGATION
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


function initNavigation() {
  const menuToggleBtn = document.querySelector('.js-menu-toggle');
  const siteHeader = document.querySelector('.site-header');
  const menuDropdown = document.querySelector('.js-menu-dropdown');
  const submenuBtns = document.querySelectorAll('.js-submenu-btn');

  // Safety check for main menu elements
  if (!menuToggleBtn || !siteHeader || !menuDropdown) return;

  const menuIcon = menuToggleBtn.querySelector('.menu-icon');

  // Toggle main menu state
  menuToggleBtn.addEventListener('click', function(e) {
    e.preventDefault();

    const isOpen = siteHeader.classList.toggle('is-active');
    menuDropdown.classList.toggle('is-active', isOpen);

    // Sync SVG animation class if SVG icon is present
    if (menuIcon) {
      menuIcon.classList.toggle('is-open', isOpen);
      menuIcon.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    // Update button accessibility attribute
    menuToggleBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  // Toggle submenus (Accordion style, mobile/tablet only)
  submenuBtns.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      // Only trigger if window width is less than 992px
      if (window.innerWidth >= 992) return;

      e.preventDefault();
      
      const parentItem = btn.closest('.main-dropdown__item');
      if (!parentItem) return;

      // Check if the clicked item is already active
      const isActive = parentItem.classList.contains('is-active');

      // Close all other open submenus
      const allDropdownItems = document.querySelectorAll('.main-dropdown__item');
      allDropdownItems.forEach(function(item) {
        item.classList.remove('is-active');
      });

      // If it wasn't active before, open it now
      if (!isActive) {
        parentItem.classList.add('is-active');
      }
    });
  });
}

// Invoke navigation initialization
initNavigation();






  
/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    WRAP LINES SCRIPT
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/




/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    TRIGGER OBSERVER
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


function triggerObserver() {



// MAIN SCRIPT FOR TRIGGERING
    
    function observe(setupFn) {
        // Wrap the entire parsing and observing execution in a 500ms delay
        setTimeout(() => {
            const isMobile = window.innerWidth < 992;
        
            // Store elements grouped by their observer options
            const elementsToObserve = [];
        
            // Helper to register elements
            const trigger = (selector, options = {}) => {
                // Global options
                const globalOptions = {
                    ...options
                };
                delete globalOptions.desktop;
                delete globalOptions.mobile;
        
                // Merge device-specific overrides
                const deviceOptions = isMobile ? {
                    ...globalOptions,
                    ...(options.mobile || {})
                } : {
                    ...globalOptions,
                    ...(options.desktop || {})
                };
        
                const {
                    threshold = 0,
                    rootMargin = '0px',
                    replay = false,
                    reversible = false,
                    debug = false,
                    disable = false,
                } = deviceOptions;
        
                if (disable) return;
        
                // Save the elements and their options for observer creation later
                document.querySelectorAll(selector).forEach(el => {
                    elementsToObserve.push({
                        el,
                        threshold,
                        rootMargin,
                        replay,
                        reversible,
                        debug
                    });
                });
            };
        
            // Run user-provided setup function
            setupFn(trigger);
        
            // Group elements by unique threshold + rootMargin combos to reuse observers
            const observerGroups = {};
        
            elementsToObserve.forEach(({
                el,
                threshold,
                rootMargin,
                replay,
                reversible,
                debug
            }) => {
                const key = `${threshold}_${rootMargin}`;
                
                el._observerOptions = {
                    replay,
                    reversible,
                    debug
                };

                if (!observerGroups[key]) {
                    observerGroups[key] = {
                        observer: new IntersectionObserver((entries, obs) => {
                            entries.forEach(entry => {
                                const options = entry.target._observerOptions || {};
                                const {
                                    replay = false,
                                    reversible = false,
                                    debug = false
                                } = options;
        
                                if (debug) console.log(entry.target, entry.isIntersecting);
        
                                if (entry.isIntersecting) {
                                    entry.target.classList.add('is-visible');
                                    if (!replay && !reversible) obs.unobserve(entry.target);
                                } else {
                                    if (replay || reversible) entry.target.classList.remove('is-visible');
                                }
                            });
                        }, {
                            threshold,
                            rootMargin
                        }),
                        elements: []
                    };
                }
        
                observerGroups[key].elements.push(el);
            });
            
            // Start observing
            Object.values(observerGroups).forEach(group => {
                group.elements.forEach(el => group.observer.observe(el));
            });
        }, 500); // 0.5s delay
    }
    
    
    
    // CALL TRIGGER
    observe(trigger => {
    
        trigger('.highlight-block__abstract p', {
            threshold: 0.5,
            //rootMargin: '400px',
            debug: true,
            replay: false,
            reversible: false
        });
    
        
    
    });

	
}


// call exmple

/*
observe(trigger => {

  trigger('.div1', {
    threshold: 0.1,
    replay: false,
    debug: true,
    mobile: {
      disable: true
    },
  });

  trigger('.div2', {
    threshold: 0,
	rootMargin: '0px',
	replay: false,
	reversible: false,
	debug: false,
	disable: false,
    desktop: {
      disable: true
    },
  });

});

*/



/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    ANIMATIONS
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/


// UNIFIED MOSAIC ANIMATION
document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.mosaic-trigger-track');
  if (!track || window.innerWidth < 991) return;

  let isTicking = false;
  let observerActive = false;

  const calculateScrollProgress = () => {
    if (!observerActive) return;

    const trackBounds = track.getBoundingClientRect();
    const totalScrollableHeight = trackBounds.height - window.innerHeight;
    
    // Calculates how far down the element has scrolled relative to the viewport top edge
    // This allows the element to be placed anywhere on the page, not just at scroll 0.
    const scrolledDepth = -trackBounds.top;
    let progress = scrolledDepth / totalScrollableHeight;
    
    // Clamp the progress strictly between 0.0 and 1.0
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    track.style.setProperty('--scroll-progress', progress.toFixed(4));
    isTicking = false;
  };

  const requestTick = () => {
    if (!isTicking) {
      requestAnimationFrame(calculateScrollProgress);
      isTicking = true;
    }
  };

  // Triggers only when the element enters/leaves the viewport
  const structuralObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        observerActive = true;
        window.addEventListener('scroll', requestTick, { passive: true });
        // Run once on entry to guarantee correct layout alignment instantly
        requestTick();
      } else {
        observerActive = false;
        window.removeEventListener('scroll', requestTick);
      }
    });
  }, {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px 0px 0px"
  });

  structuralObserver.observe(track);
  
  // Cleanup for framework transitions
  window.addEventListener('beforeunload', () => {
    structuralObserver.disconnect();
    window.removeEventListener('scroll', requestTick);
  });
});






/*  
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
    DOCUMENT READY INIT
::::::::::::::::x::::::::::::::::
::::::::::::::::x::::::::::::::::
*/

$(document).ready(function () {
	console.log('App ready!');

	initCardsSwiper();
	initVideoBlock()
	initProjectSwiper();
	initMasterArticleSwiper();



	//triggerObserver();

  headerScroll();
});




(function () {
  'use strict';

  var SELECTOR = '.highlight-block__abstract p';
  var LINE_TOLERANCE = 4; // px — words within this offsetTop delta count as the same line

  var supportsObserver = 'IntersectionObserver' in window;
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var activeObservers = [];

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  function wrapWords(node, out) {
    var children = Array.prototype.slice.call(node.childNodes);
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child.nodeType === Node.TEXT_NODE) {
        var parts = child.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        for (var j = 0; j < parts.length; j++) {
          var part = parts[j];
          if (part === '') continue;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
          } else {
            var span = document.createElement('span');
            span.className = 'rv-word';
            span.textContent = part;
            frag.appendChild(span);
            out.push(span);
          }
        }
        node.replaceChild(frag, child);
      } else if (child.nodeType === Node.ELEMENT_NODE) {
        wrapWords(child, out);
      }
    }
  }

  function buildLines(el) {
    var original = el.dataset.revealOriginal;
    var temp = document.createElement('span');
    temp.innerHTML = original;
    el.innerHTML = '';
    el.appendChild(temp);

    var words = [];
    wrapWords(temp, words);
    if (!words.length) return [];

    var lines = [];
    var currentTop = null;
    var currentLine = [];
    words.forEach(function (word) {
      var top = word.offsetTop;
      if (currentTop === null || Math.abs(top - currentTop) > LINE_TOLERANCE) {
        if (currentLine.length) lines.push(currentLine);
        currentLine = [word];
        currentTop = top;
      } else {
        currentLine.push(word);
      }
    });
    if (currentLine.length) lines.push(currentLine);

    el.innerHTML = '';
    var lineInners = [];
    lines.forEach(function (lineWords) {
      var mask = document.createElement('span');
      mask.className = 'rv-line';
      var inner = document.createElement('span');
      inner.className = 'rv-line-inner';

      var range = document.createRange();
      range.setStartBefore(lineWords[0]);
      range.setEndAfter(lineWords[lineWords.length - 1]);
      inner.appendChild(range.extractContents());

      mask.appendChild(inner);
      el.appendChild(mask);
      lineInners.push(inner);
    });

    return lineInners;
  }

  function setupParagraphs(elements) {
    if (!supportsObserver || prefersReducedMotion) {
      elements.forEach(function (el) {
        el.classList.add('reveal-lines--static');
      });
      return;
    }

    var globalLineIndex = 0;

    elements.forEach(function (el) {
      var parentBlock = el.closest('.highlight-block__abstract');

      var stagger = parseInt(
        el.dataset.revealStagger || (parentBlock && parentBlock.dataset.revealStagger) || '130',
        10
      );
      var duration = parseInt(
        el.dataset.revealDuration || (parentBlock && parentBlock.dataset.revealDuration) || '750',
        10
      );
      var baseDelay = parseInt(
        el.dataset.revealDelay || (parentBlock && parentBlock.dataset.revealDelay) || '0',
        10
      );
      var once = (el.dataset.revealOnce || (parentBlock && parentBlock.dataset.revealOnce)) !== 'false';

      var lineInners = buildLines(el);
      if (!lineInners.length) {
        el.classList.add('reveal-lines--static');
        return;
      }

      el.style.setProperty('--rv-duration', duration + 'ms');

      // Stagger each line within this specific paragraph
      lineInners.forEach(function (line, localIndex) {
        var delay = baseDelay + localIndex * stagger;
        line.style.transitionDelay = delay + 'ms';
      });

      globalLineIndex += lineInners.length;
      el.classList.add('reveal-lines--ready');

      // Set up individual observer per paragraph
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              el.classList.add('is-visible');
              if (once) observer.unobserve(el);
            } else if (!once) {
              el.classList.remove('is-visible');
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          observer.observe(el);
        });
      });

      activeObservers.push(observer);
    });
  }

  function rebuildAll() {
    activeObservers.forEach(function (obs) {
      obs.disconnect();
    });
    activeObservers = [];

    var blocks = document.querySelectorAll('.highlight-block__abstract');
    blocks.forEach(function (block) {
      var paragraphs = Array.prototype.slice.call(block.querySelectorAll('p'));
      
      paragraphs.forEach(function (el) {
        var wasVisible = el.classList.contains('is-visible');
        el.classList.remove('reveal-lines--ready', 'is-visible', 'reveal-lines--static');
        
        setupParagraphs([el]);

        if (wasVisible) {
          el.classList.add('reveal-lines--no-transition', 'is-visible');
          void el.offsetHeight;
          el.classList.remove('reveal-lines--no-transition');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (!el.dataset.revealOriginal) {
        el.dataset.revealOriginal = el.innerHTML;
      }
    });

    var blocks = document.querySelectorAll('.highlight-block__abstract');
    blocks.forEach(function (block) {
      var paragraphs = Array.prototype.slice.call(block.querySelectorAll('p'));
      if (paragraphs.length) {
        setupParagraphs(paragraphs);
      }
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(debounce(rebuildAll, 50));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', debounce(rebuildAll, 200));
})();